{
  "nl": {
    "levels": {
      "actions": {
        "add_customer": "Klant toevoegen",
        "cancel": "Annuleer",
        "changeLevel": "Wijzig niveau",
        "changeTargetGroup": "Doelgroep Aanpassen",
        "delete": "Verwijderen",
        "removeCustomer": "Klant loskoppelen",
        "requestUnits": "Verzoek extra units",
        "save": "Opslaan"
      },
      "building": "Gebouw",
      "customers": "Klanten",
      "descriptions": {
        "mupCantDelete": "Het lijkt erop dat je nog steeds units in dit project hebt. Om het project te verwijderen, raden we je aan om eerst de units te verwijderen. Op deze manier zijn we 100% zeker dat het project verwijderd kan worden.",
        "mupCantDeleteDeactivate": "Een alternatief voor het verwijderen van het project is het deactiveren. Op deze manier blijft alle informatie bewaard voor toekomstig gebruik. Wil je dit project deactiveren?"
      },
      "labels": {
        "activity": "Activiteit",
        "aftercare": "Nazorg",
        "allLevels": "Alle niveaus",
        "contacts": "Contacten",
        "conversations": "Gesprekken",
        "decisions": "Beslissingen",
        "deleteProject": "Weet je zeker dat je {project_name} wilt verwijderen",
        "deleteProjectDisclaimer": "Het verwijderen van dit project zal resulteren in het permanente verlies van alle data en inhoud. Deze actie is onomkeerbaar. Als alternatief kun je overwegen het project te deactiveren om alle informatie te bewaren voor toekomstig gebruik. Ga voorzichtig te werk.",
        "deleteWarning": "Wees voorzichtig! Als u dit niveau verwijdert, worden alle onderliggende niveaus, documenten, aankondigingen, FAQs en taken met betrekking tot dit niveau verwijderd.",
        "documents": "Documenten",
        "download": "Download {level_name}",
        "generatingExport": "Genereer export",
        "hide": "Verberg",
        "information": "Informatie",
        "installment": "Financiën",
        "milestones": "Workflows",
        "multiple_selection": "Selecteer meerdere",
        "mupCantDelete": "Oh-nee, deze actie is niet mogelijk!",
        "needMoreUnits": "Meer units nodig?",
        "reachedMax": "Je hebt de unit aangemaakt die aan dit project is toegewezen. | Je hebt de {count} units aangemaakt die aan dit project zijn toegewezen.",
        "reachedMaxRundle": "Je hebt de limiet van 1 actieve unit bereikt. | Je hebt de limiet van {count} actieve units bereikt.",
        "requestMoreUnits": "Neem contact op met het Ziggu-team als je meer actieve units nodig hebt.",
        "settings": "Projectinstellingen",
        "sharedWith": "Gedeeld met ",
        "showForLevel": "Toon {object} voor niveau",
        "spaces": "Ruimtes",
        "surveys": "Enquêtes",
        "task_assignments": "Taken",
        "tickets": "Gesprekken",
        "todos": "Taken (oud)",
        "willBeAssigned": "Beschikbaar voor iedereen in",
        "willBePublished": "Zal getoond worden aan iedereen in",
        "willBeUploaded": "Zal opgeladen worden naar"
      },
      "lot": "Lot",
      "phase": "Fase",
      "project": "Project",
      "tooltip": {
        "add_level": "{level} toevoegen",
        "fixed_project_deactivation": "Dit project valt onder het oude prijsmodel en kan niet worden gedeactiveerd. Het project en de units blijven toegankelijk zolang je Ziggu-abonnement actief is."
      },
      "unit": "Unit"
    }
  }
}
